import type { VenueDetail } from '@/lib/api/apiTypes';
import { useAuth } from '@/lib/auth/auth';
import { venueDetailKeys } from '@/features/venues/useVenueDetail';
import { useQueries } from '@tanstack/react-query';
import * as React from 'react';

export function useVenueSwitcherDetails(venueIDs: string[]) {
  const request = useAuth((state) => state.request);

  const queries = useQueries({
    queries: venueIDs.map((venueID) => ({
      queryKey: venueDetailKeys.detail(venueID),
      enabled: Boolean(venueID),
      queryFn: () => request<VenueDetail>(`/venues/${venueID}`),
      staleTime: 60_000,
    })),
  });

  return React.useMemo(() => {
    const detailMap = new Map<string, VenueDetail>();
    queries.forEach((query, index) => {
      const venueID = venueIDs[index];
      if (!venueID || !query.data) {
        return;
      }
      detailMap.set(venueID, query.data);
    });
    return detailMap;
  }, [queries, venueIDs]);
}
